
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/ask-help",
      function () {
        return require("private-next-pages/ask-help.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/ask-help"])
      });
    }
  